import { render, staticRenderFns } from "./PersonsAutoComplete.vue?vue&type=template&id=33bb3ec0&scoped=true&"
import script from "./PersonsAutoComplete.vue?vue&type=script&lang=ts&"
export * from "./PersonsAutoComplete.vue?vue&type=script&lang=ts&"
import style0 from "./PersonsAutoComplete.vue?vue&type=style&index=0&id=33bb3ec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb3ec0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VExpandTransition,VList,VListItem,VRow,VTextField,VTooltip})
